/* eslint-disable react/prop-types */
import classes from "./create-announcement.module.scss";
import Flex from "@/components-library/layout/flex";
import Button from "@/components-library/widgets/button";
import GeographicalArea from "./geographilcal-area";
import Deatil from "./detail";
import MoreInfos from "./more-infos";
import OnlyBackend from "./only-backend";
import Status from "./status";
import MainInfos from "./main-infos";
import CorrelatedArea from "./correlated-area";
import Modal from "@/components-library/widgets/modal";
import Spinner from "@/components-library/widgets/spinner";
import * as admin from "@/views/admin-dashboard/admin.slice";

function CreateAnnouncement({
  announcement,
  announcements,
  services,
  onUpdateAnnouncement,
  onClickConfirm,
  isConfirmEnabled,
  onClickBack,
  onClickDelete,
  status,
}) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="center"
      className={classes.form}
    >
      <Modal
        isOpen={
          status === admin.Status.CREATING ||
          status === admin.Status.DELETING ||
          status === admin.Status.UPDATING
        }
      >
        <Spinner />
      </Modal>
      <Flex
        align="flex-start"
        direction="row"
        justify="center"
        className={classes.actions}
      >
        <Button
          onClick={onClickBack}
          size="sm"
          color="primary"
          className={classes.action}
        >
          INDIETRO
        </Button>

        <Button
          onClick={onClickDelete}
          size="sm"
          color="primary"
          isEnabled={announcement?.id !== undefined}
          className={classes.action}
        >
          ELIMINA
        </Button>
      </Flex>

      <MainInfos
        announcement={announcement}
        updateAnnouncement={onUpdateAnnouncement}
      />
      <Status
        announcement={announcement}
        updateAnnouncement={onUpdateAnnouncement}
      />

      <GeographicalArea
        announcement={announcement}
        updateAnnouncement={onUpdateAnnouncement}
      />

      <Deatil
        announcement={announcement}
        updateAnnouncement={onUpdateAnnouncement}
      />
      <MoreInfos
        announcement={announcement}
        updateAnnouncement={onUpdateAnnouncement}
      />

      <CorrelatedArea
        announcements={announcements}
        services={services}
        announcement={announcement}
        updateAnnouncement={onUpdateAnnouncement}
      />

      <OnlyBackend
        announcement={announcement}
        updateAnnouncement={onUpdateAnnouncement}
      />
      <Button
        size="sm"
        color="primary"
        className={classes.button}
        isEnabled={isConfirmEnabled}
        onClick={onClickConfirm}
      >
        CONFERMA
      </Button>
    </Flex>
  );
}

export default CreateAnnouncement;
